import { IEditableSectionState } from './EditableSection.types';

export const setModel = (
  newModel: any,
  state: IEditableSectionState,
  setState: (state: IEditableSectionState) => void,
  onChange?: (newModel: any) => void,
  modelId?: string
) => {
  if (!modelId) {
    if (onChange) {
      onChange(newModel);
    }
  }
  setState({ ...state, model: newModel });
};

export const switchEditMode = (
  state: IEditableSectionState,
  setState: (state: IEditableSectionState) => void,
  preventReset?: boolean
) => {
  if (state.editMode && !preventReset) {
    setState({
      ...state,
      model: { ...state.oldCopy },
      editMode: false
    });
  } else {
    setState({ ...state, editMode: !state.editMode });
  }
};
